import { floorCarousels } from './glide'

const showTower = tower => {
  let $container = document.querySelector('.floors-container')
  if( $container.classList.contains('x:hide') ) {
    $container.classList.remove('x:hide')
  }
  document.querySelectorAll('[data-tower]').forEach($tower => {
    $tower.classList.toggle('x:hide', $tower.getAttribute('data-tower') !== tower)
    $tower.classList.toggle('active', $tower.getAttribute('data-tower') === tower)
  })

  floorCarousels()

  $('html, body')
  .animate({
    scrollTop: $container.offsetTop
  })
}

const towerSelector = () => {
  
  floorCarousels()

  let areas = document.querySelectorAll('.area-picker')
  areas.forEach(area => {
    area.addEventListener('click', (e) => {
      e.preventDefault()
      let tower = area.getAttribute('href').replace('#', '')
      showTower(tower)
    })
  })
}
export default towerSelector
